"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZoomInIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ZoomInIcon = () => {
    return ((0, jsx_runtime_1.jsx)("svg", { width: "24", height: "24", xmlns: "http://www.w3.org/2000/svg", children: (0, jsx_runtime_1.jsxs)("g", { fill: "none", "fill-rule": "evenodd", children: [(0, jsx_runtime_1.jsx)("path", { d: "M0 0h24v24H0z" }), (0, jsx_runtime_1.jsx)("path", { d: "M12 6a1 1 0 0 1 1 1v4h4a1 1 0 0 1 0 2h-4v4a1 1 0 0 1-2 0v-4H7a1 1 0 0 1 0-2h4V7a1 1 0 0 1 1-1z", fill: "#F7F8FC" })] }) }));
};
exports.ZoomInIcon = ZoomInIcon;
